import { getColorScheme as e, listenForSchemeChange as t } from "../colorScheme.js";
import { isInIframe as n } from "./initConfig.js";
import { checkCSSVersion as r, initCSS as i } from "./initCSS.js";
import { getConsoleStyle as a } from "./styledLogs.js";
import { usedUikitVersion as o } from "./usedUikitVersion.js";
import { doNotUseTailwind as s } from "./doNotUseTailwind.js";
import { checkForReleaseVersion as c } from "./checkForReleaseVersion.js";
import { initPiiObserver as l } from "./initPiiObserver.js";
//#region src/utils/init/initDocumentBootstrapping.ts
var u = async () => {
	if (document?.documentElement) {
		if (i(), l(), e(), t(), await c(), r(), !n) {
			let e = (e) => console.log("%c%s", a(), e);
			e("- - - - - - - - - - - - - - - - - -"), o(), e("- - - - - - - - - - - - - - - - - -");
		}
		await s();
	}
};
//#endregion
export { u as initDocumentBootstrapping };

//# sourceMappingURL=initDocumentBootstrapping.js.map